<template>
  <v-container>
    <v-form>
      <v-text-field
              id="username"
              :label="$t('field.user')"
              v-model="username"
      />
      <v-text-field
              id="password"
              :label="$t('field.password')"
              v-model="password"
      />
      <div class="button-group">
        <v-btn
                :color="buttonPrimaryColor"
                @click="login()"
        >
          {{ $t('nav.login') }}
        </v-btn>
<!--        <v-btn-->
<!--                text-->
<!--                secondary-->
<!--                @click="refreshToken()"-->
<!--        >-->
<!--          Refresh Token-->
<!--        </v-btn>-->
      </div>
      <div class="button-group">
        <a v-if="loginGoogle" :href="$store.state.endpoints.loginGoogle">
          <img src="@/assets/google-signin-button.png" />
        </a>
      </div>
      <div v-if="loginFacebook" class="button-group">
        <a :href="$store.state.endpoints.loginFacebook">
          <img src="@/assets/facebook-sign-in-button.png" />
        </a>
      </div>

    </v-form>
  </v-container>
</template>

<script>

import {refreshToken, requestToken} from "../authentication";
import Colors from "../mixins/Colors";

export default {
  name: 'Login',
  mixins: [Colors],
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      // let that = this;
      requestToken(
        this.username,
        this.password,
        response => {
          this.$store.commit('updateToken', response.data.token);
          this.$router.push({ name: 'home' });
        },
        error => {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      );

      // this.$store.dispatch('obtainToken', { username: this.username, password: this.password })
    },
    refreshToken () {
      refreshToken();
    },
    authenticate: function (provider) {
      this.$auth.authenticate(provider).then(function () {
        // Execute application logic after successful social authentication
      })
    },
  },
  computed: {
    loginFacebook () {
      return process.env.VUE_APP_HAS_FACEBOOK > 0;
    },
    loginGoogle () {
      return process.env.VUE_APP_HAS_GOOGLE > 0;
    }
  }
}
</script>

<style scoped>
  button {
    margin: 5px;
  }
  .button-group {
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
